export default __webpack_public_path__ + "static/media/IMG-20210306-WA0045.ac072306.jpg";